import { render, staticRenderFns } from "./brandSetPreview.vue?vue&type=template&id=0909eda6&scoped=true&"
import script from "./brandSetPreview.vue?vue&type=script&lang=js&"
export * from "./brandSetPreview.vue?vue&type=script&lang=js&"
import style0 from "./brandSetPreview.vue?vue&type=style&index=0&id=0909eda6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0909eda6",
  null
  
)

export default component.exports